/**
 * Converts real elapsed time into a whole number of fixed simulation steps so the
 * game runs at the same speed regardless of display refresh rate.
 */
export class FixedTimestep {
  private accumulator = 0;
  private lastTime: number | null = null;

  constructor(
    public readonly stepMs: number = 1000 / 60,
    public readonly maxStepsPerFrame: number = 5
  ) {}

  reset(now: number): void {
    this.lastTime = now;
    this.accumulator = 0;
  }

  /** Returns how many fixed steps should be simulated at time `now`. */
  advance(now: number): number {
    if (this.lastTime === null) {
      this.reset(now);
      return 1;
    }

    this.accumulator += now - this.lastTime;
    this.lastTime = now;

    // Small epsilon so float drift on exact multiples doesn't drop a step
    let steps = Math.floor((this.accumulator + 1e-6) / this.stepMs);
    this.accumulator -= steps * this.stepMs;

    if (steps > this.maxStepsPerFrame) {
      // Drop the backlog after a long stall instead of fast-forwarding
      steps = this.maxStepsPerFrame;
      this.accumulator = 0;
    }

    return steps;
  }
}
